import React from "react";
import { Navigate } from "react-router-dom";

import { authStore } from "@/store/useAuthStore";

interface AdminRouteProps {
  children: React.ReactNode;
}

const AdminRoute: React.FC<AdminRouteProps> = ({ children }) => {
  const isAdmin = authStore((state) => state.user?.role === "admin");

  return isAdmin ? <>{children}</> : <Navigate to="/home" replace />;
};

export default AdminRoute;
